var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecognitionFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.824 9.353V5.647h1.588c0 1.588-.53 3.177-1.588 3.706zm-3.85 2.01L12 10.119l-1.973 1.244.56-2.281-1.78-1.512 2.32-.166L12 5.226l.873 2.178 2.32.166-1.78 1.512.56 2.28zm-7.798-2.01c-1.058-.53-1.588-2.118-1.588-3.706h1.588v3.706zm13.236-5.294h-.53l-.198.002c-.293.005-.8.014-.86-.002V3H6.175v1.059H4.588C3.53 4.059 3 5.004 3 5.647c0 2.413.908 4.349 2.647 5.25.454.235.557.53.677.873.081.233.17.488.382.76.907 1.55 2.08 2.609 5.294 2.609 3.214 0 4.235-1.021 5.294-2.61.612-.918.645-.946 1.765-1.925l.11-.095c.77-.673 1.447-1.436 1.619-2.445.183-1.071.188-1.294.21-2.35L21 5.647c0-.643-.53-1.588-1.588-1.588zm-4.765 14.823H9.353c-1.059 0-2.118 1.06-2.118 2.118h9.53c0-1.059-1.059-2.118-2.118-2.118zm-.53-1.853a.797.797 0 01-.794.795h-2.647a.796.796 0 01-.794-.795c0-.436.358-.794.794-.794h2.647c.437 0 .795.358.795.794z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognitionFill);
export default __webpack_public_path__ + "d207e67fc1137e29a9128c25242bae0e.svg";
export { ForwardRef as ReactComponent };